<template>
  <div v-if="product">
    <div class="pharmacy-list">
      <div class="delivery text-uppercase">
        {{ $t('product_pharmacy_list.premium_delivery') }}
      </div>
      <PriceList :product="product" :category="category" class="pricelist p-4" />
    </div>
  </div>
</template>


<script>
import get from "lodash/get";
import PriceList from "@/components/PriceList";

export default {
  name: "product-pharmacy-list",
  components: {
    PriceList,
  },
  props: {
    product: Object,
  },
  data() {
    return {
      quantity: "1",
    };
  },
  computed: {
    category() {
      var categories = get(this, "product.categories");
      if (!categories) {
        return undefined;
      }
      if (!categories[0]) {
        return undefined;
      }
      return categories[0].uuid;
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        product_pharmacy_list: {
          premium_delivery: "Premium delivery for your radius of action:",
        },
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.picture {
  border: 1px solid $grey4-color;
}

.picture a {
  cursor: zoom-in;
}

.zoom {
  background-color: $corp-color2;
  color: white;
  font-size: 2rem;
  height: 3rem;
  margin-left: auto;
  margin-top: -3rem;
  padding-left: 0.5rem;
  position: relative;
  width: 3rem;
  z-index: 1;
}

.product-name {
  color: $text-third-color;
  font-size: $font-size-medium * 1.5;
}

.bestprice {
  color: $corp-color1;
  font-size: $font-size-medium * 1.3;
}

.price {
  color: $corp-color2;
  font-size: $font-size-medium * 2;
  font-weight: bold;
}

.order {
  border-bottom: 1px solid $grey4-color;
  border-top: 1px solid $grey4-color;
}

.return {
  color: $corp-color2;
  text-decoration: underline;
}

.pharmacy-list .delivery {
  color: $text-third-color;
  font-size: $font-size-medium * 1.5;
}

.pharmacy-list .delivery .time {
  color: $corp-color2;
}

.pricelist {
  border: 1px solid $grey4-color;
}

.discount-type {
  color: $grey5-color;
}

.no-discount-price {
  color: $grey5-color;
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
  text-decoration: line-through;
}

.discount-box {
  background-color: $discount-bg-color;
  color: $white;
  font-size: $font-size-medium * 1.1;
  font-weight: bold;
}
</style>
